<template>
  <div class="scrollable-container">
    <app-overlay-loading :loading="loading" />
    <v-toolbar flat :color="themeColor">
      <v-text-field
        v-model="name"
        class="search-input"
        placeholder="搜尋"
        color="black"
        prepend-inner-icon="search"/>

      <v-tooltip bottom>
        <v-btn
          @click.stop="refresh"
          slot="activator"
          flat
          icon>
          <v-icon>refresh</v-icon>
        </v-btn>
        <span>刷新</span>
      </v-tooltip>
    </v-toolbar>
    <v-tabs
      :color="themeColor"
      slider-color="accent"
      v-model="tab"
      height="32"
      grow>
      <v-tab ripple>
        訊息
      </v-tab>
      <v-tab v-if="isStudent" ripple>
        我的最愛
      </v-tab>
    </v-tabs>
    <div class="overflow-y-auto">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <chats-message />
        </v-tab-item>

        <v-tab-item v-if="isStudent">
          <chats-favorite />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import ChatsMessage from './ChatsMessage';
import ChatsFavorite from './ChatsFavorite';

export default {
  components: {
    'chats-message': ChatsMessage,
    'chats-favorite': ChatsFavorite
  },

  data() {
    return {
      loading: false,
      tab: null,
      filterTimeout: null
    };
  },

  computed: {
    name: {
      get() {
        return this.$store.state.user.filter.name;
      },
      set(value) {
        if (value === this.name) {
          return;
        }
        clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
          this.$store.commit('user/updateFilter', {name: value});
        }, 500);
      }
    }
  },

  methods: {
    ...mapActions('user', {
      loadContacts: 'loadContacts'
    }),

    async refresh() {
      this.loading = true;
      try {
        await this.loadContacts();
      } catch (e) {
        log.error(e.message);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>

.message-favorite-container {
  border-right: 1px solid lighten($primary-color, 4%) !important;
  min-width: 30vw;
  background-color: white;
}
</style>
